import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")!

  return (_openBlock(), _createBlock(_component_DxTabPanel, {
    "data-source": $data.tabs,
    "animation-enabled": true,
    loop: false,
    "defer-rendering": false,
    height: "100%"
  }, {
    item: _withCtx(({ data }) => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(data.component), {
        "employee-id": $props.employeeId,
        "employee-row": $props.employeeRow,
        key: $props.employeeId
      }, null, 8, ["employee-id", "employee-row"]))
    ]),
    _: 1
  }, 8, ["data-source"]))
}